import React, { useState } from 'react';
import { Menu, MenuItem, Button } from '@mui/material';
import { getCourseMenu } from '../Courses/actionsMenu';

export const CourseActions = ({ id, courseActionMenu, course }) => {
  const actions = getCourseMenu(courseActionMenu) ?? [];

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isMenuOpen = Boolean(anchorEl);

  return (
    <>
      <Button
        id={`${id}__button_actions`}
        className={`myOdu__button secondary ${isMenuOpen ? 'rowEditIcon--active' : 'rowEditIcon'}`}
        variant="outlined"
        onClick={handleOpen}
      >
        Actions
      </Button>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        id={`${id}__menu_actions`}
      >
        {actions.length &&
          actions.map((action, index) => (
            <MenuItem
              id={`${id}__menuItem_actions_${index}`}
              key={index}
              onClick={() => {
                action.handler(course);
                handleClose();
              }}
            >
              {action.title}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};
